import React, { useEffect, useState } from "react";
import useExceptionHandler from "hooks/useExceptionHandler";
import { CompaniaManager } from "managers";
import useMessage from "hooks/useMessage";
import useConfirm from "hooks/useConfirm";
import {
    Container,
    Row,
    Col,
    Card,
    Alert,
    Button,
    Spinner,
    Badge,
    ListGroup
} from 'react-bootstrap';
const DesvincularCuentaQuickbooks = ({
    showLoading,
    hideLoading,
    onDesvinculacionExitosa
}) => {
    const { handleException } = useExceptionHandler();
    const { Message } = useMessage();
    const { Confirm, Types } = useConfirm();
    const [desvinculacionExitosa, setDesvinculacionExitosa] = useState(false);
    const logo = require("../../assets/img/quickbooks.png")
    useEffect(() => {

        desvincularCuenta();
    }, []);


    const desvincularCuenta = () => {
        showLoading();

        CompaniaManager.devincularCuentaQuickbooks()
            .then((res) => {
                Message({ message: `Cuenta Desvinculada Exitosamente` });
                setDesvinculacionExitosa(true);

                if (onDesvinculacionExitosa) {
                    onDesvinculacionExitosa(true);
                }
            })
            .catch((e) => {
                handleException(e);
            })
            .finally(() => hideLoading());
    };


    const handleGoToDashboard = () => {
        window.location.href = '/dashboard';
    };


    // Si la desvinculación fue exitosa, mostrar mensaje de despedida
    if (desvinculacionExitosa) {
        return (
            <Container fluid className="min-vh-100 d-flex align-items-center justify-content-center bg-light">
                <Row className="w-100 justify-content-center">
                    <Col xs={12} sm={8} md={6} lg={4}>
                        <Card className="shadow-lg border-0">
                            <Card.Body className="p-5">

                                <div className="text-center mb-4">
                                    <div
                                        className="mx-auto mb-3 d-flex align-items-center justify-content-center rounded-circle"
                                        style={{ width: '7rem', height: '7rem' }}
                                    >
                                        <img
                                            src={logo}
                                            alt="QuickBooks Logo"
                                            style={{ width: '7rem', height: '7rem' }}
                                        />
                                    </div>
                                </div>
                                <div className="text-center">
                                    <h3 className="text-warning">¡Hasta pronto, QuickBooks!</h3>
                                    <p className="text-muted mb-4">
                                        Tu cuenta de QuickBooks ha sido desvinculada exitosamente.
                                    </p>
    
                                    <Button
                                        variant="primary"
                                        size="lg"
                                        onClick={handleGoToDashboard}
                                        className="w-100"
                                    >
                                        Ir al Dashboard
                                    </Button>
                                </div>
                            </Card.Body>
                            <Card.Footer className="bg-light border-0 text-center">
                                <small className="text-muted">
                                    <div>Desvinculación segura de QuickBooks Online</div>
                                    <div>Todos los datos han sido procesados de forma segura</div>
                                </small>
                            </Card.Footer>
                        </Card>
                    </Col>
                </Row>
            </Container>
        );
    }

    return null;
};

export default DesvincularCuentaQuickbooks;